<template>
    <div id="templatePane">
        <div class="hero-section shade-40">
            <div class="hero-section-text row column">
                <h1>Setup Workplace Chat on an Android device</h1>
            </div>
        </div>
        <section id="mainContent" class="row column">
            <p>Make sure you've already <a href="/help-25849">installed and setup the Workplace app</a> before you try and set up Workplace Chat.</p>
            <ol>
                <li>Go to the Google Play Store and search for <a target="_blank" href="https://play.google.com/store/apps/details?id=com.facebook.workchat">Workplace Chat by Facebook</a>
                <p><img src="/static/images/help/25850-1.png" alt="" /></p></li>
                <li>Tap <strong>INSTALL</strong>.
                <p><img src="/static/images/help/25850-2.png" alt="" /></p></li>
                <li>Once the installation is complete tap <strong>OPEN</strong>.
                <p><img src="/static/images/help/25850-3.png" alt="" /></p></li>
                <li>Tap <strong>CONTINUE AS</strong>.
                <p><img src="/static/images/help/25850-4.png" alt="" /></p></li>
                <li>Tap <strong>CONTINUE</strong>.
                <p><img src="/static/images/help/25850-5.png" alt="" /></p></li>
                <li>Workplace Chat is now setup and you're ready to go.
                <p><img src="/static/images/help/25850-6.png" alt="" /></p></li>
            </ol>
            <p>Need more help?  Browse our <a href="/help">list of articles.</a></p>
        </section>
    </div>
</template>
<script>
    export default {
    name: 'Help25850'
}
</script>